import ninegrid from "../index.js";
import { ngImport } from "./ngImport.js";
import { ngExport } from "./ngExport.js";
import { ngContextMenu } from "./ngContextMenu.js";

class ngMenu extends HTMLElement
{
	#owner;
	#importer;
	#exporter;
	
	constructor () {
		super();
		
		this.#importer = new ngImport(this.#owner);
		this.#exporter = new ngExport(this.#owner);
	}
	
	connectedCallback() {
		
		this.#owner = this.getRootNode().host.getRootNode().host;
		
		this.innerHTML = '';

		var contextMenu = new ngContextMenu({
			owner: this.#owner,
			items: {
				filtering: {
					name: "Filtering",
					className: 'ng-menu-filtering',
				},
				maximize: {
					name: "Maximize",
					className: "maximize",
				},
				export: {
					name: "export",
					items: {
						"export-excel": {
							name: 'Excel',
							className: "export-excel",
						},
						"export-pdf": {
							name: 'Pdf',
							className: "export-pdf",
							disabled: function(key, opt) {
								return true;
							},
						},
					},
				},
				import: {
					name: "import",
					className: "import",
					disabled: function(key, opt) {
						return true;
					},
				},
				properties: {
					name: 'options',
					items: {
						"show-title-bar": {
							name: 'title bar show/hide',
							className: 'show-title-bar',
						},
						"show-menu-icon": {
							name: 'menu icon show/hide',
							className: 'show-menu-icon',
						},
						"show-status-bar": {
							name: 'status bar show/hide',
							className: "show-status-bar",
						},
						/**
						"col-indicator-type": {
							name: 'grid top line show/hide',
							className: 'col-indicator-type',
						}, */
						"show-tfoot": {
							name: 'table footer show/hide',
							className: 'show-tfoot',
							disabled: function(key, opt) {
								return $(".ng-table tfoot", this.getRootNode().host).length > 0 ? false : true;
							},
						},
						"select-type": {
							name: 'select type',
							items: {
								[`select-type-${ninegrid.SELECTTYPE.ROW}`]	: { name: "row",			className: `select-type select-type-${ninegrid.SELECTTYPE.ROW}`	},
								[`select-type-${ninegrid.SELECTTYPE.ROWS}`]: { name: "multi row",		className: `select-type select-type-${ninegrid.SELECTTYPE.ROWS}`},
								[`select-type-${ninegrid.SELECTTYPE.COL}`]	: { name: "column",			className: `select-type select-type-${ninegrid.SELECTTYPE.COL}`	},
								[`select-type-${ninegrid.SELECTTYPE.COLS}`]: { name: "multi column",	className: `select-type select-type-${ninegrid.SELECTTYPE.COLS}`},
								[`select-type-${ninegrid.SELECTTYPE.CELL}`]: { name: "cell",			className: `select-type select-type-${ninegrid.SELECTTYPE.CELL}`},
								[`select-type-${ninegrid.SELECTTYPE.AREA}`]: { name: "area",			className: `select-type select-type-${ninegrid.SELECTTYPE.AREA}`},
								[`select-type-${ninegrid.SELECTTYPE.NONE}`]: { name: "none",			className: `select-type select-type-${ninegrid.SELECTTYPE.NONE}`},
							},
						},
						"paging-type": {
							name: 'paging type',
							items: {
								[`paging-type-${ninegrid.PAGINGTYPE.NONE}`]	: { name: "none",		className: `paging-type paging-type-${ninegrid.PAGINGTYPE.NONE}`	},
								[`paging-type-${ninegrid.PAGINGTYPE.CLIENT}`]	: { name: "client",		className: `paging-type paging-type-${ninegrid.PAGINGTYPE.CLIENT}`	},
								[`paging-type-${ninegrid.PAGINGTYPE.SERVER}`]	: { name: "server",		className: `paging-type paging-type-${ninegrid.PAGINGTYPE.SERVER}`	},
								"paging-count": {
									name: "entries per page",
									items: {
										[`paging-count-${ninegrid.PAGINGCOUNT.AUTO}`]			: { name: "auto",	className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.AUTO}`		},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_1}`]		: { name: "1",		className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_1}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_5}`]		: { name: "5",		className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_5}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_10}`]		: { name: "10",		className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_10}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_20}`]		: { name: "20",		className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_20}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_30}`]		: { name: "30",		className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_30}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_50}`]		: { name: "50",		className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_50}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_100}`]		: { name: "100",	className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_100}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_1000}`]		: { name: "1000",	className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_1000}`	},
										[`paging-count-${ninegrid.PAGINGCOUNT.NUM_10000}`]	: { name: "10000",	className: `paging-count paging-count-${ninegrid.PAGINGCOUNT.NUM_10000}`},
									},
								},	
							},
						},
						"auto-fit-col": {
 							name: 'auto fit columns',
							className: 'auto-fit-col',
						},
					},
				},
			},
			callback : e => {
				switch (e.menuId) {
				case "maximize":
					//ninegrid.j.querySelectorAll(this.#owner).hasClass("ng-maximize") ? ninegrid.j.querySelectorAll(this.#owner).removeClass("ng-maximize") : ninegrid.j.querySelectorAll(this.#owner).addClass("ng-maximize");
					
					//if (ninegrid.j.querySelectorAll(this.#owner).hasClass("ng-maximize")) {
						$('ng-max-popup', this.#owner.shadowRoot).remove();
						$(this.#owner.shadowRoot).append($('<ng-max-popup></ng-max-popup>'));
						//setTimeout(() => {
						this.#owner.shadowRoot.querySelector("ng-max-popup").popup();
						//}, 100);
						
					//}
					break;
				case "import":
					this.#importer.importExcel();
					break;
				case "export-excel":
					/*
					$('ng-export', this.#owner.shadowRoot).remove();
					$(this.#owner.shadowRoot).append($('<ng-export></ng-export>'));
					this.#owner.shadowRoot.querySelector("ng-export").exportExcel();
					*/
					this.#owner.export();
					break;
				case "export-pdf":
					$('ng-export', this.#owner.shadowRoot).remove();
					$(this.#owner.shadowRoot).append($('<ng-export></ng-export>'));
					this.#owner.shadowRoot.querySelector("ng-export").exportPdf();
					break;
					
				case "detail":
					break;
				
				case "filtering":
					this.#owner.filtering.isFiltering() ? this.#owner.filtering.off() : this.#owner.filtering.on();
					break;
				
				case `select-type-${ninegrid.SELECTTYPE.ROW}`:
				case `select-type-${ninegrid.SELECTTYPE.ROWS}`:
				case `select-type-${ninegrid.SELECTTYPE.COL}`:
				case `select-type-${ninegrid.SELECTTYPE.COLS}`:
				case `select-type-${ninegrid.SELECTTYPE.CELL}`:
				case `select-type-${ninegrid.SELECTTYPE.AREA}`:
				case `select-type-${ninegrid.SELECTTYPE.NONE}`:
					this.#owner.setAttribute("select-type", e.menuId.replace("select-type-", ""));
					break;
				
				case "show-title-bar":
					this.#owner.setAttribute("show-title-bar", this.#owner.getAttribute("show-title-bar") == "true" ? "false" : "true");
					break;
				case "show-menu-icon":
					this.#owner.setAttribute("show-menu-icon", this.#owner.getAttribute("show-menu-icon") == "true" ? "false" : "true");
					break;

				case "show-status-bar":
					this.#owner.setAttribute("show-status-bar", this.#owner.getAttribute("show-status-bar") == "true" ? "false" : "true");
					break;
				
				case `paging-type-${ninegrid.PAGINGTYPE.NONE}`:
				case `paging-type-${ninegrid.PAGINGTYPE.CLIENT}`:
				case `paging-type-${ninegrid.PAGINGTYPE.SERVER}`:
					this.#owner.setAttribute("paging-type", e.menuId.replace("paging-type-", ""));
					break;
				case `paging-count-${ninegrid.PAGINGCOUNT.AUTO}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_1}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_5}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_10}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_20}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_30}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_50}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_100}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_1000}`:
				case `paging-count-${ninegrid.PAGINGCOUNT.NUM_10000}`:
					this.#owner.setAttribute("paging-count", e.menuId.replace("paging-count-", ""));
					break;
				case "col-indicator-type":
					this.#owner.setAttribute("col-indicator-type", this.#owner.getAttribute("col-indicator-type") == ninegrid.COLINDICATORTYPE.EXPAND ? ninegrid.COLINDICATORTYPE.COLLAPSE : ninegrid.COLINDICATORTYPE.EXPAND);
					break;
				case "auto-fit-col":
					this.#owner.setAttribute("auto-fit-col", this.#owner.getAttribute("auto-fit-col") == "true" ? "false" : "true");
					break;
				case "show-tfoot":
					this.#owner.setAttribute("show-tfoot", this.#owner.getAttribute("show-tfoot") == "true" ? "false" : "true");
					break;
				default:
					console.log(e.menuId);
				}
			},
			events : {
				show : e => {
					ninegrid.j.querySelectorAll(this.#owner).hasClass("ng-maximize") ? ninegrid.j.querySelectorAll("ng-context-menu-panel .maximize", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .maximize", this.#owner.shadowRoot).removeClass("on");
					
					this.#owner.getAttribute("show-title-bar") == "true" ? ninegrid.j.querySelectorAll("ng-context-menu-panel .show-title-bar", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .show-title-bar", this.#owner.shadowRoot).removeClass("on");
					this.#owner.getAttribute("show-menu-icon") == "true" ? ninegrid.j.querySelectorAll("ng-context-menu-panel .show-menu-icon", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .show-menu-icon", this.#owner.shadowRoot).removeClass("on");
					this.#owner.getAttribute("show-status-bar") == "true" ? ninegrid.j.querySelectorAll("ng-context-menu-panel .show-status-bar", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .show-status-bar", this.#owner.shadowRoot).removeClass("on");

					ninegrid.j.querySelectorAll("ng-context-menu-panel .select-type", this.#owner.shadowRoot).removeClass("on");
					ninegrid.j.querySelectorAll(`ng-context-menu-panel .select-type-${this.#owner.getAttribute("select-type")}`, this.#owner.shadowRoot).addClass("on");

					ninegrid.j.querySelectorAll("ng-context-menu-panel .paging-type", this.#owner.shadowRoot).removeClass("on");
					ninegrid.j.querySelectorAll(`ng-context-menu-panel .paging-type-${this.#owner.getAttribute("paging-type")}`, this.#owner.shadowRoot).addClass("on");
					
					ninegrid.j.querySelectorAll("ng-context-menu-panel .paging-count", this.#owner.shadowRoot).removeClass("on");
					ninegrid.j.querySelectorAll(`ng-context-menu-panel .paging-count-${this.#owner.getAttribute("paging-count")}`, this.#owner.shadowRoot).addClass("on");

					this.#owner.filtering.isFiltering() ? ninegrid.j.querySelectorAll("ng-context-menu-panel .ng-menu-filtering", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .ng-menu-filtering", this.#owner.shadowRoot).removeClass("on");
					
					this.#owner.getAttribute("auto-fit-col") == "true" ? ninegrid.j.querySelectorAll("ng-context-menu-panel .auto-fit-col", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .auto-fit-col", this.#owner.shadowRoot).removeClass("on");
					
					this.#owner.getAttribute("col-indicator-type") == ninegrid.COLINDICATORTYPE.EXPAND ? ninegrid.j.querySelectorAll("ng-context-menu-panel .col-indicator-type", this.#owner.shadowRoot).addClass("on") : ninegrid.j.querySelectorAll("ng-context-menu-panel .col-indicator-type", this.#owner.shadowRoot).removeClass("on");

					const tfoot = this.#owner.body.querySelector(".ng-table tfoot");
					const tfootMenu = ninegrid.j.querySelectorAll("ng-context-menu-panel .show-tfoot", this.#owner.shadowRoot);
					
					if (tfoot) {
						tfootMenu.removeClass("disabled");
						tfoot.style.visibility == "collapse" ? tfootMenu.removeClass("on") : tfootMenu.addClass("on");
					}
					else {
						tfootMenu.addClass("disabled");
					}
					
					if (typeof ExcelJS == "undefined") {
						ninegrid.j.querySelectorAll("ng-context-menu-panel .import,ng-context-menu-panel .export-excel", this.#owner.shadowRoot).addClass("disabled");
					}
					
					ninegrid.j.querySelectorAll("ng-context-menu-panel .import,ng-context-menu-panel .export-pdf", this.#owner.shadowRoot).addClass("disabled");
					
					this.#owner.closest("dialog") ? ninegrid.j.querySelectorAll("ng-context-menu-panel .maximize", this.#owner.shadowRoot).addClass("disabled") : ninegrid.j.querySelectorAll("ng-context-menu-panel .maximize", this.#owner.shadowRoot).removeClass("disabled");
				},
				hide : () => {
				},
			},
		});

		
		
		$(this.#owner.shadowRoot.querySelector("ng-head").shadowRoot.querySelector("ng-menu")).on("click", e => { contextMenu.openMenu(e.offsetX, e.offsetY); });
	};
}

if (!customElements.get('ng-menu')) {
	customElements.define("ng-menu", ngMenu);
}
